import {dateFormatter, numberFormatter} from "../../gridFormatters";

export const backupHostOccupancyDefs = [
    {
        "field": "collection_date",
        "headerName": "Collection Date",
        "cellRenderer": dateFormatter,
        "enableRowGroup": true
    },
    {
        "field": "device_name",
        "headerName": "Device Name"
    },
    {
        "field": "device_type_description",
        "headerName": "Device Type",
        "enableRowGroup": true
    },
    {
        "field": "host_name",
        "headerName": "Host Name",
        "enableRowGroup": true
    },
    {
        "field": "machine_type",
        "headerName": "Machine Type",
        "enableRowGroup": true
    },
    {
        "field": "os_type",
        "headerName": "OS Type",
        "enableRowGroup": true
    },
    {
        "field": "schedule_name",
        "headerName": "Schedule Name",
        "enableRowGroup": true
    },
    {
        "field": "last_backup",
        "headerName": "Last Backup Date",
        "cellRenderer": dateFormatter
    },
    {
        "field": "total_protected_gb",
        "type": "numericColumn",
        "headerName": "Total Protected GB",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "total_stored_gb",
        "type": "numericColumn",
        "headerName": "Total Stored GB",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "total_system_space_gb",
        "type": "numericColumn",
        "headerName": "Total System Space GB",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
    {
        "field": "system_used_gb",
        "type": "numericColumn",
        "headerName": "Total System Used GB",
        "aggFunc": "sum",
        "filter": "agNumberColumnFilter",
        "allowedAggFuncs": [
            "sum"
        ],
        "cellRenderer": numberFormatter,
    },
];